import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useSondertagStats from "../hooks/useSondertagStats";
import { useSondertagContext } from "../context/sondertagContext";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

export default function JahrgangHeader({ jahrgang, onToggle }) {
  const theme = useTheme();
  const { currentUser } = useAppContext();
  const { angebote } = useSondertagContext();

  const { jahrgangStats } = useSondertagStats(angebote, currentUser);

  const stats = jahrgangStats.find((j) => j.jahrgangId === jahrgang.id);

  const isComplete = stats?.total > 0 && stats?.filled === stats?.total;

  const statusColor = isComplete
    ? theme.palette.eventManager.slot.reserved
    : theme.palette.text.secondary;

  return (
    <Box
      onClick={onToggle}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: {
          xs: "space-between",
          md: "flex-start",
        },
        gap: 1,
      }}
    >
      {/* ✅ TITLE */}
      <Typography
        sx={{
          flex: { xs: 1, md: "unset" },
          minWidth: 0,
          wordBreak: "break-word",
          fontWeight: 600,

          opacity: isComplete ? 0.65 : 1,

          borderLeft: isComplete
            ? `3px solid ${theme.palette.success.main}`
            : "3px solid transparent",

          pl: 0.5,
        }}
      >
        {jahrgang.title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
          mt: {
            xs: 0, // mobile
            md: "0.15em", // desktop → push slightly after title
          },
        }}
      >
        {/* ✅ PROGRESS TEXT (subtle but informative) */}
        <Typography
          sx={{
            fontSize: "0.75rem",
            fontWeight: 600,
            opacity: stats?.filled === stats?.total ? 0.65 : 1,
            color: statusColor, // ✅ color only here
          }}
        >
          ({stats?.free} / {stats?.total})
        </Typography>

        {/* ✅ COMPLETED BADGE */}
        {isComplete && (
          <Box
            sx={{
              px: 0.6,
              py: 0.2,
              borderRadius: 1,
              backgroundColor: theme.palette.eventManager.slot.reserved,
              color: "#fff",
              fontSize: "0.65rem",
              fontWeight: 600,
            }}
          >
            ✓
          </Box>
        )}
      </Box>
    </Box>
  );
}
